import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import UserListItem from '../UserListItem/UserListItem.vue'
import DepartmentItem from '../DepartmentItem/DepartmentItem.vue'
import * as types from '../../../store/types'
import * as events from '../../../event-types'
import { dispatchEventBus } from '@appbase/util'

@Component({
	components: { UserListItem, DepartmentItem },
	computed: {
		...mapGetters({
			searchResults: types.RECIPIENT_SEARCH,
		}),
	},
})
export default class SearchResult extends Vue {
	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: G E T T E R S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	searchResults!: recipient.PagedItemList<recipient.OrgPerson> | null

	//
	// ──────────────────────────────────────────────────────── I ──────────
	//   :::::: C O M P U T E D : :  :   :    :     :        :          :
	// ──────────────────────────────────────────────────────────────────
	//

	get users() {
		return this.searchResults ? this.searchResults.items : []
	}

	//
	// ────────────────────────────────────────────────────────── I ──────────
	//   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────────
	//

	created() {
		document.addEventListener('keyup', this.onKeyup)
	}

	beforeDestroy() {
		document.removeEventListener('keyup', this.onKeyup)
	}

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: M E T H O D S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	onKeyup(event: KeyboardEvent) {
		if (event.key.toLowerCase() === 'escape') {
			dispatchEventBus(window, events.CANCEL_SEARCH, null)
		}
	}
}
